<template>
  <div class="vx-row">
    <div class="vx-col w-full mb-base">
      <form>
        <vx-card>
          <vs-row vs-w="12" class="mb-5">
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="1" vs-sm="4" vs-xs="12">
              <vs-button @click="goBack" color="danger" type="border" icon="keyboard_backspace">Back</vs-button>
            </vs-col>
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="9" vs-sm="4" vs-xs="12">
              <h3>View Grade Category</h3>
            </vs-col>
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="2" vs-sm="4" vs-xs="12">
            </vs-col>
          </vs-row>
          <vs-divider class="m-5" />
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Campaign:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              {{ gradeCategoryDescription.campaign_name }}
            </div>

          </div>

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Name:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              {{ gradeCategoryDescription.name }}
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Description:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              {{ gradeCategoryDescription.description }}
            </div>

          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Grades:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">

              {{ gradeCategoryDescription.grades }}
              <template>





              </template>

            </div>
          </div>

          <div class="vx-row mb-6" v-if = 'gradeCategoryDescription.is_opportunity'>
            <div class="vx-col sm:w-1/5 w-full">
              <span>Is Opportunity:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">

              {{ gradeCategoryDescription.is_opportunity }}
              <template>





              </template>

            </div>
          </div>
          
          <div class="vx-row mb-6" v-if = 'gradeCategoryDescription.grades_can_be_changes_by_sd'>
            <div class="vx-col sm:w-1/5 w-full">
              <span>Grades can be changed by Sales Developer:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">

              {{ gradeCategoryDescription.grades_can_be_changes_by_sd }}
              <template>





              </template>

            </div>
          </div>






        </vx-card>
      </form>
    </div>
  </div>
</template>
<script>
// Store Module
import defineAbilitiesFor from "@/config/abilities";
import moduleCampaignManagement from "@/store/campaign-management/moduleCampaignManagement.js";
import CampaignAutocomplete from "@/components/autocomplete/CampaignAutocomplete.vue";
import vSelect from "vue-select";
export default {
  beforeMount() {
  },
  data() {
    return {
      gradeCategoryDescription: [],
      gradeCategoryId: null,
      selected_campaign: null,
      selected_campaign_id: null,
      campaign_required: null,
      companySearchComponentKey: 0,
      please_choose_grades: null,
      selected: [],
      abilities: null,
      campaign_grade_lists: [],
    };
  },
  components: {
    "v-select": vSelect,
    CampaignAutocomplete,
  },
  created() {
    var self = this;
    defineAbilitiesFor().then(function (data) {
      self.abilities = data;
    });

    let userInfo = JSON.parse(localStorage.getItem("userInfo"));
    this.user_id = userInfo["uid"];
    this.user_role = userInfo["userRole"];

    if (!moduleCampaignManagement.isRegistered) {
      this.$store.registerModule(
        "campaignsManagement",
        moduleCampaignManagement
      );
      moduleCampaignManagement.isRegistered = true;
    }

  },
  mounted() {
    this.gradeCategoryId = this.$route.params.gradeCategoryId;
    this.fetchGradeCategory()

  },
  watch: {
  },
  methods: {
    fetchGradeCategory() {
      this.$store
        .dispatch("campaignsManagement/fetchGradeCategory", this.gradeCategoryId)
        .then(res => {
          this.gradeCategoryDescription = JSON.parse(res.data);
          this.gradeCategoryDescription = this.gradeCategoryDescription[0];
          this.getCampaignGrades(this.gradeCategoryDescription.campaign_id)
        })
        .catch(err => {
          console.error(err);
        });
    },
    getCampaignGrades(selected_campaign) {
      this.$store
        .dispatch(
          "campaignsManagement/getCampaignGrades",
          selected_campaign
        )
        .then(res => {
          let result = res.data;
          if (result) {
            this.campaign_grade_lists = result;
          }
          console.log(result)
        })
        .catch(err => {
          console.log(err);

          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        });
    },
    goBack: function () {
      this.$router.go(-1);
    },
  }
};
</script>
<style scoped>
.removeButton {
  cursor: pointer;
}

.removeButtonClass {
  cursor: pointer;
  position: relative;
  float: right;
  margin-top: -25px;
  margin-right: 25px;
}
</style>
